import { render, staticRenderFns } from "./multi-drug-rapid-test-cup.vue?vue&type=template&id=3e607aef&scoped=true&"
import script from "./multi-drug-rapid-test-cup.vue?vue&type=script&lang=js&"
export * from "./multi-drug-rapid-test-cup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e607aef",
  null
  
)

export default component.exports